import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useSurveyService from '../../../app/services/hooks/useSurveyService';

interface Props {
    surveyId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const SurveyMandatorySwitchChange = ({ surveyId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { changeMandatorySurvey, fetchingMandatorySurvey } = useSurveyService();

    const active = (value: boolean) => {
        setChecked(value);

        changeMandatorySurvey(surveyId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={surveyId} callback={active} />;
};

export default SurveyMandatorySwitchChange;
